import { useTranslation } from "react-i18next";

export default function PrivacyPage() {
  const { t, i18n } = useTranslation("admin");
  const isEnglish = i18n.resolvedLanguage?.toLowerCase().startsWith("en");

  const controllerEmailHref = `mailto:info@buukkeri.fi?subject=${encodeURIComponent(
    t("privacyPage.controller.emailSubject")
  )}`;

  const rightsEmailHref = `mailto:info@buukkeri.fi?subject=${encodeURIComponent(
    t("privacyPage.rights.emailSubject")
  )}`;

  return (
    <main className="min-h-screen bg-zinc-950 px-4 py-12 text-white sm:px-6">
      <section className="mx-auto max-w-3xl rounded-[2rem] border border-white/10 bg-white/[0.04] p-6 shadow-2xl sm:p-8">
        <nav className="mb-8 flex flex-wrap items-center gap-3 text-xs font-black uppercase tracking-[0.14em]">
          <a
            href={isEnglish ? "/en/" : "/"}
            className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-white no-underline transition hover:border-red-400 hover:bg-red-500/10"
          >
            {t("privacyPage.nav.home")}
          </a>

          <a
            href="/yhteys"
            className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-zinc-300 no-underline transition hover:border-red-400 hover:text-white"
          >
            {t("privacyPage.nav.contact")}
          </a>

          <span className="rounded-full border border-red-400/30 bg-red-500/10 px-4 py-2 text-red-100">
            {t("privacyPage.nav.privacy")}
          </span>

          <a
            href={isEnglish ? "/en/terms" : "/kayttoehdot"}
            className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-zinc-300 no-underline transition hover:border-red-400 hover:text-white"
          >
            {t("privacyPage.nav.terms")}
          </a>
        </nav>

        <p className="text-xs font-black uppercase tracking-[0.22em] text-red-400">
          Paranoidi
        </p>

        <h1 className="mt-4 text-4xl font-black tracking-tight text-white sm:text-5xl">
          {t("privacyPage.title")}
        </h1>

        <p className="mt-5 text-base leading-7 text-zinc-300">
          {t("privacyPage.intro")}
        </p>

        <p className="mt-4 text-sm leading-7 text-zinc-500">
          {t("privacyPage.updated")}
        </p>

        <div className="mt-8 grid gap-5 text-sm leading-6 text-zinc-400">
          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.controller.title")}
            </h2>

            <div className="mt-2 grid gap-1">
              <p>Spiderlegs Productions</p>
              <p>{t("privacyPage.controller.businessId")}</p>
              <p>{t("privacyPage.controller.address")}</p>
              <p>
                {t("privacyPage.controller.emailLabel")}{" "}
                <a
                  href={controllerEmailHref}
                  className="font-bold text-white underline-offset-4 hover:underline"
                >
                  info@buukkeri.fi
                </a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.dataProcessed.title")}
            </h2>
            <p className="mt-2">{t("privacyPage.dataProcessed.p1")}</p>
            <p className="mt-2">{t("privacyPage.dataProcessed.p2")}</p>
            <p className="mt-2">{t("privacyPage.dataProcessed.p3")}</p>
            <p className="mt-2">{t("privacyPage.dataProcessed.p4")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.purposes.title")}
            </h2>
            <p className="mt-2">{t("privacyPage.purposes.p1")}</p>
            <p className="mt-2">{t("privacyPage.purposes.p2")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.legalBases.title")}
            </h2>
            <p className="mt-2">{t("privacyPage.legalBases.p1")}</p>
            <p className="mt-2">{t("privacyPage.legalBases.p2")}</p>
            <p className="mt-2">{t("privacyPage.legalBases.p3")}</p>
            <p className="mt-2">{t("privacyPage.legalBases.p4")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.payments.title")}
            </h2>
            <p className="mt-2">{t("privacyPage.payments.p1")}</p>
            <p className="mt-2">{t("privacyPage.payments.p2")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.cookies.title")}
            </h2>
            <p className="mt-2">{t("privacyPage.cookies.p1")}</p>
            <p className="mt-2">{t("privacyPage.cookies.p2")}</p>
            <p className="mt-2">{t("privacyPage.cookies.p3")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.recipients.title")}
            </h2>
            <p className="mt-2">{t("privacyPage.recipients.p1")}</p>
            <p className="mt-2">{t("privacyPage.recipients.p2")}</p>
            <p className="mt-2">{t("privacyPage.recipients.p3")}</p>
            <p className="mt-2">{t("privacyPage.recipients.p4")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.transfers.title")}
            </h2>
            <p className="mt-2">{t("privacyPage.transfers.p1")}</p>
            <p className="mt-2">{t("privacyPage.transfers.p2")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.sources.title")}
            </h2>
            <p className="mt-2">{t("privacyPage.sources.p1")}</p>
            <p className="mt-2">{t("privacyPage.sources.p2")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.retention.title")}
            </h2>
            <p className="mt-2">{t("privacyPage.retention.p1")}</p>
            <p className="mt-2">{t("privacyPage.retention.p2")}</p>
            <p className="mt-2">{t("privacyPage.retention.p3")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.rights.title")}
            </h2>

            <p className="mt-2">{t("privacyPage.rights.p1")}</p>
            <p className="mt-2">{t("privacyPage.rights.p2")}</p>

            <p className="mt-2">
              {t("privacyPage.rights.p3BeforeEmail")}{" "}
              <a
                href={rightsEmailHref}
                className="font-bold text-white underline-offset-4 hover:underline"
              >
                info@buukkeri.fi
              </a>
              . {t("privacyPage.rights.p3AfterEmail")}
            </p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.complaints.title")}
            </h2>
            <p className="mt-2">{t("privacyPage.complaints.p1")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("privacyPage.changes.title")}
            </h2>
            <p className="mt-2">{t("privacyPage.changes.p1")}</p>
          </section>
        </div>
      </section>
    </main>
  );
}
